import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { TransportOrderIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderStatusHistoryState } from './shipment-transport-order-status-history.state';
import {
  ShipmentTransportOrderStatusHistorySetInitialState,
  ShipmentTransportOrderStatusHistoryLoad,
} from './shipment-transport-order-status-history.actions';
import { ShipmentWaybillLoadHistoryData } from './shipment-transport-order-status-history.model';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderStatusHistoryFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderStatusHistoryState.getLoaded);
  historyData$: Observable<ShipmentWaybillLoadHistoryData[]> = this.store.select(
    ShipmentTransportOrderStatusHistoryState.getHistory,
  );

  constructor(private store: Store) {}

  loadAll(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderStatusHistoryLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderStatusHistorySetInitialState());
  }
}
